module.exports = __webpack_public_path__ + "media/images/emblems/Affeltra-8552e673ef17776c4d1ba3884ef55017.png";